export const wordMsoStyles = `
    <style>
        @page WordSection1 {
            size: 21.0cm 29.7cm;
            mso-page-orientation: portrait;
            margin: 2cm 1.5cm 2cm 2.5cm;
        }
        div.WordSection1 { page: WordSection1; }
        
        @page WordSection2 {
            size: 29.7cm 21.0cm;
            mso-page-orientation: landscape; 
            margin: 1.5cm 1.5cm;
        }
        div.WordSection2 { page: WordSection2; }

        @page WordSection3 {
            size: 21.0cm 29.7cm;
            mso-page-orientation: portrait;
            margin: 2cm 1.5cm 2cm 2.5cm;
        }
        div.WordSection3 { page: WordSection3; }

        table.cv-data-table {
            width: 100% !important;
            table-layout: fixed !important;
            mso-table-layout-alt: fixed !important; 
            border-collapse: collapse;
        }
        
        table.cv-data-table th, 
        table.cv-data-table td {
            font-size: 11pt !important;
            padding: 3px 4px !important; 
            line-height: 1.1 !important;
            word-wrap: break-word;
        }
        
        /* Mục 12: Bài báo / Sách */
        th.col-tt { width: 5% !important; }
        th.col-name { width: 28% !important; }
        th.col-author { width: 16% !important; }
        th.col-journal { width: 16% !important; }
        th.col-vol { width: 11% !important; }
        th.col-page { width: 8% !important; }
        th.col-type { width: 9% !important; }
        th.col-year { width: 7% !important; }

        /* Mục 13: Đề tài, dự án KH&CN */
        th.col-proj-name { width: 40% !important; }
        th.col-proj-time { width: 20% !important; }
        th.col-proj-prog { width: 30% !important; }
        th.col-proj-status { width: 10% !important; }

        /* Mục 14: Giải thưởng */
        th.col-aw-tt { width: 5% !important; }
        th.col-aw-content { width: 82% !important; }
        th.col-aw-year { width: 13% !important; }

        /* Mục 15: Hướng dẫn Sau đại học */
        th.col-ment-tt { width: 5% !important; }
        th.col-ment-name { width: 49% !important; }
        th.col-ment-level { width: 9% !important; }
        th.col-ment-school { width: 14% !important; }
        th.col-ment-start { width: 12% !important; }
        th.col-ment-end { width: 11% !important; }
    </style>
`;